import { extend, setInteractionMode } from 'vee-validate';
import { required, is, min } from 'vee-validate/dist/rules';

setInteractionMode('aggressive');

extend('required', { ...required, message: '{_field_} can not be empty' });
extend('min', { ...min, message: '{_field_} too short' });
extend('is', { ...is, message: '{_field_} does not match' });
